import React from 'react';

import { GridRow } from './widgets/grid';

export const PageTitle = ({title}) =>
  <GridRow>
    <h1 className="mt3">{title}</h1>
  </GridRow>
